<script>
import { NodeMixin } from '@/helpers/node-mixin';
import { computed } from 'vue';

export default {
  name: 'AssignNode',
  template: '#assign-node-template',
  mixins: [NodeMixin],
  emits: ['click'],
  setup(props) {
    const variables = computed(() => Object.values(props.node.properties?.variables || {}));

    return {
      variables,
    };
  },
};
</script>
